/**
 * SubscribersCtrl controller
 * Show all subscribers
 */

import { SUBSCRIBER_STATUSES } from 'app/core/constants'
import { getName, getNetwork, unique, keyValue } from 'app/helpers/entity'

/**
 * SubscribersCtrl controller
 *
 * @class SubscribersCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:SubscribersCtrl
 */
/* @ngInject */
export default function SubscribersCtrl ($scope, $location, $timeout, authSvc, historySvc, SubscriberDTO) {
  var vm = this

  var {
    new: initSearchNew,
    disabled: initSearchDisabled,
    q: initSearchQ,
    networks: initSearchNetworks,
    subscriptions: initSubscriptions,
    distributor: initSearchDistributor,
    batch: initSearchBatch,
    statuses: initSearchStatuses,
    vod: initSearchVod,
    vodName,
    channel: initSearchChannel,
    channelName,
    tab: initSearchTab
  } = $location.search()

  vm.vodName = vodName

  vm.channelName = channelName

  // fix single batch in location search
  // batch could be specified only when there is distributor filter exists
  if (!initSearchDistributor) {
    initSearchBatch = null
  }

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   *
   */
  vm.isCSFiltered = !!initSearchVod || !!initSearchChannel

  /**
   * Subscriber statuses
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Object}
   */
  vm.subscriber_statuses = SUBSCRIBER_STATUSES

  /**
   * Subscriber statuses for filtering
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Object}
   */
  vm.subscriber_statuses_filter =
    Object.keys(SUBSCRIBER_STATUSES)
      .reduce((o, s) => { o[SUBSCRIBER_STATUSES[s].filter] = SUBSCRIBER_STATUSES[s].name; return o }, {})

  /**
   * isFound Flag
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Boolean}
   */
  vm.isFound = true

  /**
   * onlyNew flag
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Boolean}
   */
  vm.onlyNew = initSearchNew

  /**
   * onlyDisabled flag
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Boolean}
   */
  vm.onlyDisabled = initSearchDisabled

  /**
   * canViewSubscribers flag
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Boolean}
   */
  vm.canViewSubscribers = authSvc.hasAccess('viewSubscriber')

  vm.trialIncompleteFlagEnabled = authSvc.hasEnabledFlag('FEATURE_TRIAL_AND_INCOMPLETE_PAYMENTS_ENABLED')

  vm.SUBSCRIBER_TABS = { ALL: 'all', TRIAL: 'trial', INCOMPLETE: 'incomplete' }

  vm.activeTab = (vm.trialIncompleteFlagEnabled &&
    (initSearchTab === vm.SUBSCRIBER_TABS.TRIAL || initSearchTab === vm.SUBSCRIBER_TABS.INCOMPLETE))
    ? initSearchTab
    : vm.SUBSCRIBER_TABS.ALL

  /**
   * Subscribers' networks lisk
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {models.Network[]}
   */
  vm.subscribersNetworks = []

  /**
   * Subscribers' networks list count
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Number}
   */
  vm.subscribersNetworksCount = 0

  /**
   * Total count of Subscribers
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Number}
   */
  vm.total = 0

  /**
   * Function, indicating, should we show network names or no
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @function
   */
  vm.showNetworkNames = (ht) =>
    vm.subscribersNetworks.length &&
    vm.subscribersNetworks[0] &&
    ht && (
      (ht.networks && ht.networks.length) ||
      (ht.q && ht.q.length) ||
      (ht.distributor)
    )

  /**
   * Networks list,
   * Array of {key, value} objects
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Object[]}
   */
  vm.networks = []

  vm.networksById = {}

  /**
   * Distributor,
   * {key, value} object
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Object}
   */
  vm.distributor = null

  /**
   * Batch,
   * {key, value} object
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {Object[]}
   */
  vm.batch = null

  /**
   * Subscribers list
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @type {models.SubscriberDTO[]}
   */
  vm.allSubscribers = []

  /**
   * Refresh smart table state, run once
   * Only executed once after page refresh, to set network to dropdown list
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @function
   */
  const refreshTableStateOnce = once(tableState => {
    var storePObject = tableState.search.predicateObject
    tableState.search.predicateObject = {}
    $timeout(() => { tableState.search.predicateObject = storePObject }, 0)
  })

  vm.urlExtraCash = null
  vm.getOptions = function (networkIds = [], distributorId = null) {
    let url = '?'
    networkIds.forEach(id => {
      url = url + 'networks=' + id + '&'
    })
    if (distributorId) {
      url = url + 'distributor=' + distributorId + '&'
    }
    if (url.length > 1) {
      url = url.slice(0, -1)
    } else {
      url = ''
    }

    if (vm.urlExtraCash !== url) {
      SubscriberDTO.loadExtra(url).then(data => {
        if (!authSvc.hasAccess('securitySearchSubscriber')) {
          vm.networks = data.networks && data.networks.map(keyValue())
          data.networks.forEach(n => { vm.networksById[n.id] = n.name })
          vm.distributors = data.distributors && data.distributors.map(keyValue({ value: (d) => d.firstName + ' ' + d.lastName }))
          vm.batches = data.batches && data.batches.map(keyValue())
        }
        vm.subscriptions = data.subscriptions.map(s => ({ key: s.id, value: s.name }))
      })
    }

    vm.urlExtraCash = url
  }

  /**
   * Get Subscribers from backend
   *
   * @memberof mwApp/subscribers.controller:SubscribersCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getSubscribers = function (tableState) {
    // set default sort by lastname
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'lastName'
      tableState.sort.reverse = false
    }

    // add external and startup filter to predicateObject
    var pObject = tableState.search.predicateObject = tableState.search.predicateObject || {}

    pObject.disabled = vm.onlyDisabled ? 'true' : ''
    pObject.new = vm.onlyNew ? 'true' : ''

    if (initSearchNetworks) {
      pObject.networks = initSearchNetworks.split(',').map(Number)
      initSearchNetworks = null
    }
    if (initSearchDistributor) {
      pObject.distributor = Number(initSearchDistributor)
      initSearchDistributor = null
    }
    if (initSearchBatch) {
      pObject.batch = Number(initSearchBatch)
      initSearchBatch = null
    }
    if (initSearchQ) {
      pObject.q = initSearchQ
      initSearchQ = null
    }
    if (initSearchStatuses) {
      pObject.statuses = initSearchStatuses.split(',')
      initSearchStatuses = null
    }
    if (initSubscriptions) {
      pObject.subscriptions = initSubscriptions.split(',').map(Number)
      initSearchStatuses = null
    }

    if (initSearchVod) {
      pObject.vod = Number(initSearchVod)
      initSearchVod = null
    } else {
      pObject.vod = null
    }

    if (initSearchChannel) {
      pObject.channel = Number(initSearchChannel)
      initSearchChannel = null
    } else {
      pObject.channel = null
    }

    vm.getOptions(pObject.networks, pObject.distributor)

    // fix single batch in smart table search
    // batch could be specified only when there is distributor filter exists
    if (!pObject.distributor) {
      pObject.batch = null
    }

    if (initSearchTab) { initSearchTab = null }

    delete pObject.isTrial
    delete pObject.withIncompletePayments
    if (vm.trialIncompleteFlagEnabled) {
      if (vm.activeTab === vm.SUBSCRIBER_TABS.TRIAL) pObject.isTrial = true
      else if (vm.activeTab === vm.SUBSCRIBER_TABS.INCOMPLETE) pObject.withIncompletePayments = true
    }

    // set q and networks to navigation bar
    $location.search('q', pObject.q ? pObject.q : null)
    $location.search('networks', pObject.networks && pObject.networks.length ? pObject.networks.join(',') : null)
    $location.search('distributor', pObject.distributor ? pObject.distributor : null)
    $location.search('batch', pObject.batch ? pObject.batch : null)
    $location.search('statuses', pObject.statuses && pObject.statuses.length ? pObject.statuses.join(',') : null)
    $location.search('subscriptions', pObject.subscriptions && pObject.subscriptions.length ? pObject.subscriptions.join(',') : null)
    $location.search('vod', pObject.vod ? pObject.vod : null)
    $location.search('channel', pObject.channel ? pObject.channel : null)
    $location.search('tab',
      vm.trialIncompleteFlagEnabled && vm.activeTab !== vm.SUBSCRIBER_TABS.ALL
        ? vm.activeTab
        : null)

    // save history state
    historySvc.push()
    pObject.withoutOptions = true

    // if it needed to add more than one search params, it is better to make a separate directive
    pObject.exactMatch = vm.exactMatch

    // get subscribers
    SubscriberDTO.loadSmartOptions(tableState).then(
      data => {
        // content
        //

        vm.allSubscribers = data.content.content
        vm.isFound = !!vm.allSubscribers.length

        // get subscribers networks
        vm.subscribersNetworks = vm.allSubscribers
          .map(getNetwork)
          .filter(unique)
          .map(getName)
        vm.subscribersNetworks.sort()
        vm.total = data.content.totalElements

        // get count of found networks
        vm.subscribersNetworksCount = data.content.totalPackage || vm.subscribersNetworks.length

        // refresh smart table predicate object
        refreshTableStateOnce(tableState)

        $scope.loading = false
      }
    )
  }

  vm.displayingAccessoryNotes = function (subscr) {
    return subscr.accessoryNotes.filter(an => an.status === 'NOT_PROCESSED').reduce((acc, cur) => {
      return acc.concat(cur.accessories)
    }, [])
  }

  /**
   *
   */
  vm.resetCSFilter = function () {
    vm.isCSFiltered = false
    $scope.$broadcast('refreshTable', { id: 'allSubscribersTable' })
  }

  vm.selectTab = function (tab) {
    if (!vm.trialIncompleteFlagEnabled) { return }
    if (!Object.values(vm.SUBSCRIBER_TABS).includes(tab)) { return }
    if (vm.activeTab === tab) { return }
    vm.activeTab = tab
    $scope.$broadcast('refreshTable', { id: 'allSubscribersTable' })
  }

  vm.goToNotes = function (subscr) {
    if (authSvc.hasAccess('viewSubscriber')) {
      $location.url(subscr._publicUrl + '/notes#accessory_purchasing')
    }
  }

  /**
   * Helper function, to make once-executable function
   */
  function once (fn, context) {
    var result
    return function () {
      if (fn) {
        result = fn.apply(context || this, arguments) // eslint-disable-line no-invalid-this
        fn = null
      }
      return result
    }
  }
}
